import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { AnswerContent } from "@/schema/console/evaluation-reports/AnswerContent";
import AccessorCheckItem from "@/src/console/(auth)/_components/AssessmentResultDialog/QuestionList/AccessorCheckItem";
import { useTranslation } from "react-i18next";

interface QuestionRowProps {
  index: number;
  answerContent: AnswerContent;
}

function QuestionRow({ index, answerContent }: QuestionRowProps) {
  const { t } = useTranslation();
  return (
    <div className=" flex flex-col p-5 border-b border-b-cool-gray-200">
      <p className=" text-base font-medium text-cool-gray-700 mt-2">
        {index}、 {answerContent.content}
      </p>
      <RadioGroup className=" mt-5" disabled value={`${answerContent.answer}`}>
        <div className=" flex flex-row space-x-4">
          <div className=" flex flex-row space-x-2">
            <RadioGroupItem value={"1"} />
            <label htmlFor="1">{t("yes")}</label>
          </div>
          <div className=" flex flex-row space-x-2">
            <RadioGroupItem value={"2"} />
            <label htmlFor="2">{t("no")}</label>
          </div>
          <div className=" flex flex-row space-x-2">
            <RadioGroupItem value={"3"} />
            <label htmlFor="3">{t("not-applicable")}</label>
          </div>
        </div>
      </RadioGroup>
      {answerContent.extension_note && (
        <div className=" flex flex-col space-y-1 py-5">
          <p className=" text-sm font-medium text-cool-gray-600">
            {t("supplemental-information")}
          </p>
          <p className=" text-sm font-normal text-cool-gray-700">
            {answerContent.extension_note}
          </p>
        </div>
      )}
      <div className=" flex flex-col space-y-4 p-4 rounded-md bg-cool-gray-50">
        <p className=" text-sm font-medium text-cool-gray-700">
          {t("assessor-check-items")}
        </p>
        {answerContent.answer_evaluations.map((evaluation, index) => (
          <AccessorCheckItem
            key={index}
            index={index + 1}
            evaluation={evaluation}
          />
        ))}
      </div>
    </div>
  );
}

export default QuestionRow;
